import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTENT, telHref } from "../data/site";
import { scrollToSection } from "./Header";

export const CtaBanner = () => (
  <section data-testid="cta-banner" className="relative overflow-hidden bg-[#0055FF] px-6 py-24 md:px-12 md:py-28">
    <div className="absolute inset-0 blueprint-grid opacity-30" aria-hidden />
    <div className="relative mx-auto flex max-w-7xl flex-col items-start gap-10 lg:flex-row lg:items-end lg:justify-between">
      <Reveal>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/70">Start Your Project</p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[1.0] tracking-tighter text-white">
            {CONTENT.ctaHeading}
          </h2>
          <p className="mt-5 max-w-xl text-base md:text-lg text-white/80">{CONTENT.ctaText}</p>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="flex flex-wrap gap-4">
          <a
            data-testid="cta-call-now-button"
            href={telHref()}
            className="flex items-center gap-3 bg-white px-8 py-4 font-display text-sm font-bold uppercase tracking-widest text-[#0055FF] transition-all hover:scale-[1.03]"
          >
            <Phone size={16} /> Call Now — {CONTENT.phone}
          </a>
          <button
            data-testid="cta-request-quote-button"
            onClick={() => scrollToSection("#contact")}
            className="group flex items-center gap-3 border border-white/60 px-8 py-4 font-display text-sm font-bold uppercase tracking-widest text-white transition-all hover:bg-white/10"
          >
            Request a Quote
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
